import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AvailablestepsService } from './availablesteps.service';
import { UserInfoService } from './security.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()

export class VariablePopupService {
    public regXForVarFormula: any = /%[a-z]+%/g;
    public listOfUsedVariableObj: any = {};
    public listOfUsedVariableObjByType: any;
    public variablePopupPayload: any = {};
    public variablePopupOpened: any = '';
    public variablePopupPayload$ = new BehaviorSubject(this.variablePopupPayload);
    public userInfo: any;
    public enabledPermissions: any;
    public showExtVariablePopup: boolean = false;
    public fixedMappedSfFieldsObj:any = {
      "user.FirstName": "Voornaam",
      "user.LastName": "Achternaam",
      "user.Email": "E-mail",
      "user.PhoneNumber": "Telefoonnummer"
    };
    public mappedSfFieldsObj:any = {};
    public hasUpdatedAppMsgTranslations:boolean = false;
    public oldFieldsObj:any = {};

    constructor(
        private availablestepsService: AvailablestepsService,        
        private userInfoService: UserInfoService,
        private translate: TranslateService
    ) { 
      this.userInfo = this.userInfoService._info;
      this.enabledPermissions = JSON.parse(JSON.stringify(this.userInfoService.userPermissions));
      // if(this.enabledPermissions.isJRSalesforceEnabled && this.userInfo.AccountLoginType == 'salesforce' && this.enabledPermissions.isNewVariablePopupEnabled){
      if(this.enabledPermissions.isNewVariablePopupEnabled){
        this.showExtVariablePopup = true;
        this.regXForVarFormula = /%(([a-zA-Z0-9_]\.){0,1}[a-zA-Z0-9_])+%/g;
      }
      setTimeout(() => {
        this.availablestepsService.messageVariablesCategory.map(category=>{
          category.variables.map(variable=>{
            this.oldFieldsObj[variable.formula] = variable.title;
          })
        });
      }, 0);
    }

    changeInVariablePopupPayload(){
        this.variablePopupPayload$.next(this.variablePopupPayload);
    }

    removeInlineCSSForParagraphStyle(msg:any): string{
      let auxMsg = msg;
      let doc = new DOMParser().parseFromString(auxMsg, 'text/html');
      let grayTxtNode = Array.from(doc.querySelectorAll(".fr-text-gray"));
      let spacedNode = Array.from(doc.querySelectorAll(".fr-text-spaced"));
      let borderedNode = Array.from(doc.querySelectorAll(".fr-text-bordered"));
      let uppercaseNode = Array.from(doc.querySelectorAll(".fr-text-uppercase"));
      if(grayTxtNode && grayTxtNode.length > 0){
        grayTxtNode.forEach((node:any)=>{       
            node.style.color = '';
        });
      }
      if(spacedNode && spacedNode.length > 0){
        spacedNode.forEach((node:any)=>{
            node.style.letterSpacing = '';
        });
      }
      if(uppercaseNode && uppercaseNode.length > 0){
        uppercaseNode.forEach((node:any)=>{
            node.style.textTransform = '';
        });
      }
      if(borderedNode && borderedNode.length > 0){
        borderedNode.forEach((node:any)=>{
            node.style.borderTop = '';
            node.style.borderBottom = '';
            node.style.padding = '';
        });
      }
      auxMsg = doc.body.innerHTML;
      return auxMsg;
    }
  
    addInlineCSSForParagraphStyle(msg:any): string{
      let auxMsg = msg;
      let doc = new DOMParser().parseFromString(auxMsg, 'text/html');
      let grayTxtNode = Array.from(doc.querySelectorAll(".fr-text-gray"));
      let spacedNode = Array.from(doc.querySelectorAll(".fr-text-spaced"));
      let borderedNode = Array.from(doc.querySelectorAll(".fr-text-bordered"));
      let uppercaseNode = Array.from(doc.querySelectorAll(".fr-text-uppercase"));
      if(grayTxtNode && grayTxtNode.length > 0){
        grayTxtNode.forEach((node:any)=>{
            node.style.color = '#AAA';
        });
      }
      if(spacedNode && spacedNode.length > 0){
        spacedNode.forEach((node:any)=>{
          node.style.letterSpacing = '1px';
        });
      }
      if(uppercaseNode && uppercaseNode.length > 0){
        uppercaseNode.forEach((node:any)=>{
          node.style.textTransform = 'uppercase';
        });
      }
      if(borderedNode && borderedNode.length > 0){
        borderedNode.forEach((node:any)=>{
          node.style.borderTop = '1px solid #222';
          node.style.borderBottom = '1px solid #222';
          node.style.padding = '10px 0';
        });
      }
      auxMsg = doc.body.innerHTML;
      return auxMsg;
    }
  
  convertToPlainText(htmlContent) {
    // Replace <br> tags with newline characters
    htmlContent = htmlContent.replace(/<br(\s)*([^<])*>/g, "\n");

    // Create a temporary element and set its HTML content
    const tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = htmlContent;

    // Find anchor tags and process their content
    const anchorElements:any = tempDivElement.querySelectorAll('a');
    // const anchorElements = tempDivElement.querySelectorAll('a');
    // const anchorElementsArray: HTMLAnchorElement[] = Array.from(anchorElements);
    anchorElements.forEach((element:HTMLAnchorElement) => {
      const hrefText = element.getAttribute('href') || '';
      const anchorText = element.textContent || '';
      if (anchorText.trim()) {
        // Preserve both href text and anchor tag content
        const combinedText = `${anchorText} (${hrefText})`;
        element.textContent = combinedText;
      } else {
        // If the anchor tag is empty, use only the href text
        element.textContent = hrefText;
      }
    });

    // Get plain text from the modified HTML
    const text = tempDivElement.textContent || tempDivElement.innerText || '';

    // Clean up the temporary element
    tempDivElement.remove();

    return text;
  };




  /*********************************************************************************************** */
  public templateVarFormulaRegEx = /\%((([a-zA-Z0-9_]+)\.){0,1}([a-zA-Z0-9_]+))\%/g
  public formattedTemplateVarFormulaRegEx = /\#((([a-zA-Z0-9_]+)\.){0,1}([a-zA-Z0-9_]+))\%\+([\d]+)/g
 

  getListOfUsedVariableObjV3(msg: any) {
    const listOfUsedVariableObj: any[]= []
    const varCountByType: { [key: string]: number } = {};
  
    if(!msg){
      return listOfUsedVariableObj;
    }
  
    const regexToUse = this.formattedTemplateVarFormulaRegEx.test(msg)
                        ? this.formattedTemplateVarFormulaRegEx
                        : this.templateVarFormulaRegEx;
    
    regexToUse.lastIndex = 0;
    // const formulaMatchIterator = msg.matchAll(regexToUse);
    let match;
    let formulaMatchIterator = [];

    while ((match = regexToUse.exec(msg)) !== null) {
        formulaMatchIterator.push(match);
        console.log(match)
    }
  
    for (const match of formulaMatchIterator) {
      const fullVarName = match[1];
      const key = match[5] ? parseInt(match[5]) : (varCountByType[`%${fullVarName}%`] = (varCountByType[`%${fullVarName}%`] || 0) + 1)
      listOfUsedVariableObj.push({
        "formula": `%${fullVarName}%`,
        "title": this.oldFieldsObj[`%${fullVarName}%`] ||this.mappedSfFieldsObj[fullVarName] || this.fixedMappedSfFieldsObj[fullVarName] || fullVarName,
        "key": key
      });
    }
  
    return listOfUsedVariableObj;
  }

  getListOfUsedVariableFormulasInMsg(msg: any) {
    let listOfUsedVariableFormula: string[] = []

    if(!msg){
      return listOfUsedVariableFormula;
    }

    const regexToUse = this.formattedTemplateVarFormulaRegEx.test(msg)
                        ? this.formattedTemplateVarFormulaRegEx
                        : this.templateVarFormulaRegEx;
    
    let match;
    let formulaMatchIterator = [];
    regexToUse.lastIndex = 0;
    while ((match = regexToUse.exec(msg)) !== null) {
      formulaMatchIterator.push(match);
      console.log(match)
    }

    for (const match of formulaMatchIterator) {
      const fullVarName = match[1];
      listOfUsedVariableFormula.push(`%${fullVarName}%`);
    }
    return listOfUsedVariableFormula;
  }

    //get api data
  updateTemplateVariableIntoHTMLV3(msg: string, type:boolean=false): string {
    let listOfUsedVariableObj: any[] = this.getListOfUsedVariableObjV3(msg);
    const variableNodeObjToDisplay: { [key: string]: string } = {};

    if (!msg || !listOfUsedVariableObj || listOfUsedVariableObj.length === 0) {
      return msg || '';
    }

    if(!type){ 
      msg = msg.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

      msg = this.removeInlineCSSForParagraphStyle(msg);

        if (listOfUsedVariableObj && listOfUsedVariableObj.length > 0) {

          listOfUsedVariableObj.forEach(variable => {
            const regExpString = variable.formula.replace(/\%/g, '\\%');
            const regExp = new RegExp(regExpString);

            variableNodeObjToDisplay[`${variable.formula}+${variable.key}`] = this.createVariableTagElementsV3(variable);

            msg = msg.replace(regExp, variableNodeObjToDisplay[`${variable.formula}+${variable.key}`]);
          });

          return msg;

    }
  }


  createVariableTagElementsV3(variable:any){
    return `<span class="fr-deletable d-inline-block" id="${variable.formula.replace('\%', '\#')}+${variable.key}" contenteditable="false"><span class="editor-var-tag">${variable.title}</span>&nbsp;</span>`;
  }


  insertFormulaIntoEditorV3(listOfVariableObjToBeUsed: any, templateFroala: any) {
    let newVariables: any = [];
    let newVariableObj: any = {};
    let msg: any;

    let listOfUsedVariableFormula: any = templateFroala.editorRefernce.html.get().match(this.formattedTemplateVarFormulaRegEx) || [];
    
    if (listOfVariableObjToBeUsed && listOfVariableObjToBeUsed.length > 0) {
      listOfVariableObjToBeUsed.map(varItem => {
        if (listOfUsedVariableFormula && !listOfUsedVariableFormula.includes(varItem.formula.replace('\%', '\#') + '+' + varItem.key)) {
          newVariables.push(varItem);
        }
      });

      let oldfroalContent = templateFroala.editorRefernce.html.get();
      templateFroala.editorRefernce.selection.restore();

      if(newVariables && newVariables.length > 0){
        newVariables.forEach(variable => {
          newVariableObj[`${variable.formula}+${variable.key}`]  = this.createVariableTagElementsV3(variable);
        });
        templateFroala.editorRefernce.html.insert(Object.values(newVariableObj).join('&nbsp;'));
      }

      msg = templateFroala.editorRefernce.html.get();
      var doc = new DOMParser().parseFromString(msg, 'text/html');
      listOfUsedVariableFormula.map(formula => {
        if (!(listOfVariableObjToBeUsed && listOfVariableObjToBeUsed.includes(listOfVariableObjToBeUsed.find(variable => variable.formula.replace('\%', '\#') + '+' + variable.key === formula)))) {
          if (doc.getElementById(formula)) {
            doc.getElementById(formula).remove();
            msg = doc.body.innerHTML;
          }
        }
      });
      templateFroala.editorRefernce.html.set(msg);
    } else {
      msg = templateFroala.editorRefernce.html.get();
      var doc = new DOMParser().parseFromString(msg, 'text/html');
      listOfUsedVariableFormula.map(formula => {
        if (doc.getElementById(formula)) {
          doc.getElementById(formula).remove();
          msg = doc.body.innerHTML;
        }
      });
      templateFroala.editorRefernce.html.set(msg);
    }

    setTimeout(() => {
      let editableonContainer = document.getElementsByClassName("fr-element");
      
      let range = document.createRange();
      let sel = window.getSelection();
      if (newVariables && newVariables.length > 0) {
        let lastInsertEl;
        lastInsertEl = <Node>document.getElementById(newVariables[newVariables.length - 1].formula);

        if (lastInsertEl) {
          range.setStartAfter(lastInsertEl);
        }

      } else {
        range.setStartAfter(editableonContainer[0].lastChild);
      }
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      templateFroala.editorRefernce.events.focus(true);
      newVariables = [];
    }, 50);
    return msg;
  }

  updateTemplateVarHTMLIntoVariableCommon(msg: any): string {
    msg = this.stripFroalaMarkers(msg);
    let listOfUsedVariableObj = this.getListOfUsedVariableObjV3(msg);    
    
    let msgtxt: string = msg ? msg : '';
    msgtxt = this.addInlineCSSForParagraphStyle(msgtxt);

    if (msgtxt) {      
      if (listOfUsedVariableObj && listOfUsedVariableObj.length > 0) {
        listOfUsedVariableObj.map(varItem => {
          msgtxt = this.removeVarHTMLStructureCommon(msgtxt, varItem);
        });
      }
      let regxToRep = new RegExp(`(href=["'].*?)({{|%7[Bb]%7[Bb])(slinkBtn|rclinkBtn)(}}|%7[Dd]%7[Dd])(.*?["'])`, "g");
      msgtxt = msgtxt.replace(regxToRep, `$1{{$3}}$5`);
    }

    return msgtxt;
  }
  
  removeVarHTMLStructureCommon(msgtxt:any, varItem:any){
    let partialDocInnerhtml;

    const doc = new DOMParser().parseFromString(msgtxt, 'text/html');
    const targetElementId = `${varItem.formula.replace('\%', '\#')}+${varItem.key}`;

    const partialDocElement = doc.getElementById(targetElementId);

    if(partialDocElement){
     
      partialDocInnerhtml = varItem.formula
      partialDocElement.outerHTML = partialDocInnerhtml;
      msgtxt = doc.body.innerHTML;
    }

    return msgtxt;

  }

/**
 * Strip Froala internal fr-marker spans from HTML so they are not saved (they appear on paste).
 */
  private stripFroalaMarkers(html: string): string {
    if (html == null || typeof html !== 'string') return html;
    return html.replace(/<span\s+class="fr-marker"[^>]*>[\s\S]*?<\/span>/gi, '');
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/variable-popup.service.ts